import React from "react";

const QuoteIcon = props => (
  <svg width={50} height={39} className="ico-quote" {...props}>
    <defs>
      <linearGradient
        x1="-65.269%"
        y1="53.356%"
        x2="103.565%"
        y2="52.02%"
        id="a"
      >
        <stop stopColor="#2B95FF" offset="0%" />
        <stop stopColor="#7F55FF" offset="100%" />
      </linearGradient>
    </defs>
    <path
      d="M5.007 38.412c-.437.296-1.532.555-2.173-.156l-1.182-1.487c-.572-.967.12-1.863.57-2.235 2.13-1.768 3.68-3.136 4.647-4.103 1.897-1.994 3.299-3.99 4.224-5.98.212-.456-.329-.745-.61-.837C3.496 21.324 0 17.286 0 11.501c0-3.408 1.132-6.177 3.395-8.306C5.658 1.065 8.495 0 11.9 0c3.035 0 5.725 1.384 8.067 4.153 2.29 2.609 3.434 5.432 3.434 8.467 0 8.895-6.131 17.492-18.395 25.792zm26.597 0c-.436.296-1.531.555-2.172-.156l-1.182-1.487c-.572-.967.12-1.863.569-2.235 2.13-1.768 3.68-3.136 4.648-4.103 1.896-1.994 3.298-3.99 4.224-5.98.211-.456-.329-.745-.61-.837-6.988-2.29-10.483-6.328-10.483-12.113 0-3.408 1.132-6.177 3.394-8.306C32.256 1.065 35.092 0 38.5 0c3.035 0 5.724 1.384 8.067 4.153C48.856 6.762 50 9.585 50 12.62c0 8.895-6.132 17.492-18.396 25.792z"
      transform="rotate(180 25 19.356)"
      fill="url(#a)"
    />
  </svg>
);

export default QuoteIcon;
